import { Input, Stack } from '@etg/wings';
import { ReactComponent as RevolutValidationIcon } from '@eti/assets/icons/revolut/exclamation-mark.svg';
import { useProperty, useRevolut, useTranslation, useValidation } from '@eti/providers';
import { Field as ReduxFormField } from 'redux-form';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const InputComponent = ({
  className,
  description,
  input,
  label,
  labelRef,
  meta,
  name,
  placeholder,
  shouldMarkInputAsRequired,
  ...rest
}) => {
  const {
    nonDebugT
  } = useTranslation();
  const {
    p
  } = useProperty();
  const {
    isRevolut
  } = useRevolut();
  const hasError = Boolean(meta.invalid && !meta.active && (input.value !== '' || meta.touched));
  const hasWarning = Boolean(meta.warning && !meta.active && (input.value !== '' || meta.touched));
  const errorId = `${name}-error`;
  const labelId = `${name}-label`;
  const descriptionId = description ? `${name}-description` : undefined;
  const resolvedLabel = shouldMarkInputAsRequired ? nonDebugT('Input.Field.Required', label) : label;
  return /*#__PURE__*/_jsxs(Stack, {
    className: className,
    spacing: 4,
    children: [/*#__PURE__*/_jsx(Input, {
      "aria-labelledby": `${labelId} ${errorId}`,
      descriptionId: descriptionId,
      errorId: errorId,
      hasError: hasError,
      hasFloatingLabel: p('CustomerWeb.FloatingInputLabels.Enabled'),
      hasWarning: hasWarning,
      id: name,
      label: resolvedLabel,
      labelId: labelId,
      labelRef: labelRef,
      placeholder: placeholder && placeholder.length > 0 ? placeholder : undefined,
      required: Boolean(shouldMarkInputAsRequired),
      ...rest,
      ...input
    }), /*#__PURE__*/_jsx(Input.Meta, {
      description: description,
      descriptionId: descriptionId,
      error: meta.error,
      errorId: errorId,
      hasError: hasError,
      hasWarning: hasWarning,
      iconPrefix: isRevolut ? /*#__PURE__*/_jsx(RevolutValidationIcon, {}) : undefined,
      warning: meta.warning
    })]
  });
};
const capitalizeValue = string => string !== null && string !== void 0 && string[0] ? string[0].toLocaleUpperCase() + string.slice(1) : string;
const ConnectedInput = ({
  name,
  normalize,
  onBlur,
  onChange,
  onFocus,
  shouldForceCapitalize,
  validationRuleName,
  warningRuleName,
  ...props
}) => {
  const validate = useValidation(validationRuleName);
  const warning = useValidation(warningRuleName);
  const normalizeFunc = shouldForceCapitalize || normalize ? value => {
    let normalizedValue = value;
    if (shouldForceCapitalize) {
      normalizedValue = capitalizeValue(normalizedValue);
    }
    if (typeof normalize === 'function') {
      normalizedValue = normalize(normalizedValue);
    }
    return normalizedValue;
  } : undefined;
  return /*#__PURE__*/_jsx(ReduxFormField, {
    component: InputComponent,
    name: name,
    normalize: normalizeFunc,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    props: {
      name,
      ...props
    },
    validate: validate,
    warn: warning
  });
};
export default ConnectedInput;
//# sourceMappingURL=ConnectedInput.js.map